<template>
  <!-- Modal -->
  <div
    class="modal"
    ref="modal"
    id="radio-modal"
    tabindex="-1"
    aria-labelledby="radio-modal-label"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-fullscreen-md-down modal-dialog-centered"
      ref="modalDialog"
    >
      <div class="modal-content">
        <div class="modal-header d-flex justify-content-between">
          <h5 class="modal-title" id="radio-modal-label">
            <span class="material-symbols-outlined">radio</span>
            Radio
          </h5>
          <div class="d-flex">
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="close"
            ></button>
          </div>
        </div>
        <div class="modal-body">
          <div class="alert alert-warning mb-0 d-flex align-content-center">
            <span class="material-symbols-outlined me-2">lightbulb</span>
            Ich wollte hier eigentlich ein Radio einbetten mit ein paar
            Playlisten auf Spotify, die mir bei der Motivation geholfen haben.
            Allerdings bieten viele Künstler für eingebettete Spotify-Links nur
            Vorschau-Varianten ihrer Titel an, die gerade mal 30 Sekunden
            dauern. Statt die Titel also einzubinden, habe ich sie hier nur
            verlinkt, bis mir eine bessere Lösung einfällt.
          </div>
          <div class="accordion accordion-flushed" id="spotifyAccordion">
            <div
              class="accordion-item"
              v-for="(quellen, kategorie) in spotifyquellen"
              :key="kategorie"
            >
              <h2 class="accordion-header" :id="'heading-' + kategorie">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  :data-bs-target="'#collapse-' + kategorie"
                  aria-expanded="false"
                  :aria-controls="'collapse-' + kategorie"
                  @click="toggleKategorie(kategorie)"
                >
                  {{ kategorietitel(kategorie) }}
                </button>
              </h2>
              <div
                :id="'collapse-' + kategorie"
                class="accordion-collapse collapse"
                :aria-labelledby="'heading-' + kategorie"
                data-bs-parent="#spotifyAccordion"
              >
                <div class="accordion-body">
                  <div
                    v-for="spotifyquelle in quellen"
                    :key="spotifyquelle.id"
                    class="mb-3"
                  >
                    <div v-if="geoeffneteKategorien[kategorie]">
                      <div v-if="true">
                        <a href="#" @click.prevent="openSpotify(spotifyquelle)">
                          {{ spotifyquelle.name }}
                        </a>

                        <div
                          class="text-normal alert alert-info"
                          v-if="spotifyquelle.showWebPlayerLink"
                        >
                          Konnte die Spotify-App nicht geöffnet werden?<br />
                          <a
                            class="d-flex align-items-center"
                            :href="spotifyquelle.showWebPlayerLink"
                            target="_blank"
                          >
                            <span
                              class="material-symbols-outlined me-2 text-decoration-none"
                              >launch</span
                            >
                            Hier im Web-Player öffnen.</a
                          >
                        </div>
                      </div>

                      <iframe
                        v-if="false"
                        style="border-radius: 12px"
                        :src="
                          'https://open.spotify.com/embed/' +
                          spotifyquelle.typ +
                          '/' +
                          spotifyquelle.urlid +
                          '?utm_source=generator'
                        "
                        width="100%"
                        height="152"
                        allowfullscreen=""
                        allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                        loading="lazy"
                      ></iframe>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="resize-handler" @mousedown="startResize"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "bootstrap";
import { notify } from "@kyvg/vue3-notification";
import { collection, doc, getDoc, getDocs } from "firebase/firestore";
import { firebaseAuth, firebaseDb } from "@/main";
import { onAuthStateChanged } from "firebase/auth";
import interact from "interactjs";

export const TRAININSEINHEIT_ANLEGEN_MODAL_ELEMENT_ID = "radio-modal";

export default {
  data() {
    return {
      modalInstance: null,
      x: 0,
      y: 0,
      spotifyquellen: {},
      geoeffneteKategorien: {},
      showWebPlayerLink: null,
      istAdmin: false,
    };
  },
  computed: {},
  async mounted() {
    interact(this.$refs.modalDialog).draggable({
      inertia: true,
      allowFrom: ".modal-header",
      modifiers: [
        interact.modifiers.restrictRect({
          restriction: "parent",
          endOnly: true,
        }),
      ],
      listeners: {
        move: this.dragMoveListener,
      },
    });

    onAuthStateChanged(firebaseAuth, async (user) => {
      if (!user) {
        this.$router.push("/login");
      }
    });
  },
  methods: {
    kategorietitel(kategorie) {
      if (kategorie === "penAndPaper") {
        return `📝️ Pen & Paper`;
      }

      if (kategorie === "musik") {
        return `🎵️ Musik`;
      }

      if (kategorie === "podcast") {
        return `🗣️ Podcast`;
      }

      return kategorie;
    },

    toggleKategorie(kategorie) {
      this.geoeffneteKategorien[kategorie] =
        !this.geoeffneteKategorien[kategorie];
    },

    openSpotify(spotifyquelle) {
      const spotifyLink = `spotify:${spotifyquelle.typ}:${spotifyquelle.urlid}`;
      const webLink = `https://open.spotify.com/${spotifyquelle.typ}/${spotifyquelle.urlid}`;

      // Versuche, die Spotify-App zu öffnen
      window.open(spotifyLink, "_blank");

      // Zeige einen Hinweis mit direktem Link zum Web-Player
      setTimeout(() => {
        spotifyquelle.showWebPlayerLink = webLink; // Speichert den Link für die Anzeige
      }, 1000);
    },

    async open() {
      try {
        const userDocRef = doc(
          firebaseDb,
          "benutzer",
          firebaseAuth.currentUser.uid
        );

        const userDocSnap = await getDoc(userDocRef);

        if (userDocSnap.exists()) {
          this.istAdmin = userDocSnap.data().istAdmin;
        }

        const spotifyquellenSnap = await getDocs(
          collection(firebaseDb, "spotifyquellen")
        );

        const spotifyquellenListe = spotifyquellenSnap.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        this.spotifyquellen = spotifyquellenListe.reduce((acc, quelle) => {
          if (!acc[quelle.kategorie]) {
            acc[quelle.kategorie] = [];
          }

          acc[quelle.kategorie].push(quelle);

          acc[quelle.kategorie].sort((a, b) =>
            a.name.localeCompare(b.name, "de")
          );

          return acc;
        }, {});
      } catch (error) {
        notify({
          title: "Fehler",
          text: "Leider konnten die Daten nicht geladen werden.",
          type: "error",
          duration: 5000,
        });

        console.error("Fehler beim Laden der Daten:", error);
      }

      const modalElement = document.getElementById(
        TRAININSEINHEIT_ANLEGEN_MODAL_ELEMENT_ID
      );

      this.modalInstance = new Modal(modalElement, {
        backdrop: false,
        keyboard: false,
      });

      this.modalInstance.show();

      // Stelle sicher, dass das Modal in der Mitte startet
      this.$nextTick(() => {
        document.body.classList.remove("modal-open");
        this.$refs.modal.removeAttribute("aria-hidden");

        const modalDialog = this.$refs.modalDialog;

        if (modalDialog) {
          modalDialog.style.top = "50%";
          modalDialog.style.left = "50%";
          modalDialog.style.transform = "translate(-50%, -50%)";
        }
      });
    },

    dragMoveListener(event) {
      this.x += event.dx;
      this.y += event.dy;

      event.target.style.transform = `translate(${this.x}px, ${this.y}px)`;
    },

    close() {
      this.x = 0;
      this.y = 0;
      this.$refs.modalDialog.style.transform = "none";

      if (this.modalInstance) {
        this.modalInstance.hide();
      }
    },

    startResize(event) {
      const modalContent = this.$refs.modalDialog;
      const initialWidth = modalContent.offsetWidth;
      const initialHeight = modalContent.offsetHeight;
      const initialX = event.clientX;
      const initialY = event.clientY;

      const mouseMoveHandler = (e) => {
        const width = initialWidth + (e.clientX - initialX);
        const height = initialHeight + (e.clientY - initialY);

        // Setze die neue Breite und Höhe
        modalContent.style.width = `${width}px`;
        modalContent.style.height = `${height}px`;
      };

      const mouseUpHandler = () => {
        document.removeEventListener("mousemove", mouseMoveHandler);
        document.removeEventListener("mouseup", mouseUpHandler);
      };

      document.addEventListener("mousemove", mouseMoveHandler);
      document.addEventListener("mouseup", mouseUpHandler);
    },
  },
};
</script>

<style scoped>
.modal {
  pointer-events: none !important;
}

.modal-dialog {
  position: fixed !important;
}

.modal-header {
  cursor: grab;
  user-select: none;
}

.modal-header:active {
  cursor: grabbing;
}

.modal-content {
  cursor: default;
  width: 100%;
  max-width: 90vw; /* Maximale Breite für das Modal */
  max-height: 90vh; /* Maximale Höhe für das Modal */
  overflow: hidden;
}

.resize-handler {
  width: 16px;
  height: 16px;
  background: #ddd;
  cursor: se-resize;
  position: absolute;
  bottom: 0;
  right: 0;
}

.modal-body {
  overflow-y: auto;
}

/* CUSTOM */
.accordion-item,
.accordion-button {
  font-weight: bold;
  border-radius: 0 !important;
}

.modal-body {
  padding: 0;
}
</style>
